import * as React from "react";
import { useMappedState } from "redux-react-hook";
import * as _ from "lodash";

import { TabbedNavigation } from "src/library/components/TabbedNavigation";
import {
  Layout,
  MainContentWrapper
} from "src/core/shared/components/Layout";
import { PageProps } from "src/pages/Router/routes";
import { IStore } from "src/core/shared/store/index";

import UserSettingsTab from "./UserSettingsTab";
import PaymentMethodSettingsTab from "./PaymentMethodsSettingsTab";
import TransactionsTab from "../../../modules/payment/components/TransactionsTab/TransactionsTab";

/**
 * User settings page
 */
const UserSettingsPage: React.ReactFCWithChildren<PageProps<unknown>> = props => {
  const { location, terminology } = props;
  const defaultTab = React.useMemo(() => location.hash.replace("#", ""), [ location.hash ]);

  const { installedModules, currentRole } = useMappedState((store: IStore) => ({
    installedModules: store.global.settings?.installedModules || [],
    currentRole: store.global.role
  }));

  const tabs = React.useMemo(() => {
    const pageTabs = [
      {
        title: "Account",
        name: "account",
        content: () => <UserSettingsTab />
      }
    ];

    const cardPermission = _.find(currentRole?.permissions, permission => permission.code === "view-payment-method");

    // only show the payments tab if the module is installed
    if (installedModules.includes("payment") && cardPermission) {
      pageTabs.push({
        title: "Payment methods",
        name: "payment_methods",
        content: () => <PaymentMethodSettingsTab terminology={terminology} />
      });

      pageTabs.push({
        title: "Payments",
        name: "transactions",
        content: () => (
          <TransactionsTab
            terminology={terminology}
          />
        )
      });
    }

    return pageTabs;
  }, [
    installedModules,
    terminology,
    currentRole
  ]);

  return (
    <Layout {...props}>
      <MainContentWrapper fill>
        <TabbedNavigation
          defaultTab={defaultTab}
          tabs={tabs}
        />
      </MainContentWrapper>
    </Layout>
  );
};

export default UserSettingsPage;
